import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, FremiumGuard } from '../../guards';
import { DirectShipComponent } from './direct-ship/direct-ship.component';
import { SpecialComponent } from './specials/special.component';
import { BasicComponent } from './basic/basic.component';
import { CampaignsComponent } from './campaigns.component';

const children = [
  {
    path: 'lista', component: CampaignsComponent, children: [
      { path: '', component: SpecialComponent, outlet: 'campanhas' },
      { path: 'especiais', component: SpecialComponent, outlet: 'campanhas' },
      { path: 'basicas', component: BasicComponent, outlet: 'campanhas' },
      { path: 'envio-direto', component: DirectShipComponent, outlet: 'campanhas' },
    ]
  },
];

export const routes: Routes = [
  { path: 'campaign', canActivate: [AuthGuard, FremiumGuard], children },
  { path: 'campanhas', canActivate: [AuthGuard, FremiumGuard], children },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CampaignRoutingModule {
}
